import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Checkbox,
} from "@mui/material";

const CardList = ({
  data = [], // Данные по умолчанию
  config = [], // Конфигурация по умолчанию
  viewMode,
  onDelete,
  selectedItems,
  onSelectItem,
  renderActions,
}) => {
  const isAppsMode = viewMode === "apps"; // Проверка для режима "apps"

  return (
    <Box
      sx={{
        display: isAppsMode ? "flex" : "grid",
        flexDirection: isAppsMode ? "column" : "unset",
        gridTemplateColumns: isAppsMode ? "unset" : "repeat(4, 1fr)",
        gap: 2,
        margin: isAppsMode ? "0 auto" : 0,
        maxWidth: isAppsMode ? "1550px" : "unset",
        padding: 2,
        backgroundColor: "#ffffff",
        border: "1px solid #ccc",
        borderRadius: "12px",
      }}
    >
      {/* Проверка наличия данных */}
      {data.length > 0 ? (
        data.map((item) => (
          <Card
            key={item.id}
            sx={{
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: 2,
              width: isAppsMode ? "98%" : "unset",
              position: "relative",
            }}
          >
            {/* Чекбокс для выбора строки */}
            <Checkbox
              sx={{ position: "absolute", top: 8, left: 8 }}
              checked={selectedItems.includes(item.id)}
              onChange={() => onSelectItem(item.id)}
            />

            <CardContent>
              {/* Динамическое отображение данных на основе config */}
              {config.map((col) => (
                <Typography key={col.field} variant="body2">
                  <strong>{col.label}:</strong>{" "}
                  {item[col.field] !== null && item[col.field] !== undefined
                    ? item[col.field]
                    : "—"}
                </Typography>
              ))}
            </CardContent>

            {/* Кнопка удаления */}
            {renderActions?.(item)}
            <Button
              size="small"
              color="error"
              onClick={() => onDelete(item.id)}
            >
              Удалить
            </Button>
          </Card>
        ))
      ) : (
        <Typography align="center" sx={{ margin: 2 }}>
          Нет данных для отображения
        </Typography>
      )}
    </Box>
  );
};

export default CardList;
